import { render, staticRenderFns } from "./ym-loss.vue?vue&type=template&id=63b83d52&scoped=true&"
import script from "./ym-loss.vue?vue&type=script&lang=js&"
export * from "./ym-loss.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b83d52",
  null
  
)

export default component.exports